export const formFloatInvErrors = {
  'documentTypeError': false,
  'legalRepresentativeTypeError': false,
  'documentError': false,
  'documentFileError': false,
  'namesError': false,
  'lastNamesError': false,
  'clientTypeError': false,
  'dealerReservationError': false,
  'adviserCodeError': false,
  'certificateError': false,
  'certificateFileError': false,
  'discapacityPercentageError': false,
  'exonerationPercError': false,
  'discapacityPercError': false,
  'representativeError': false,
  'legalRepresentativeIdError': false,
  'legalRepresentativeNameError': false,
  'locationError': false,
  'cityError': false,
  'provinceError': false,
  'countryError': false,
  'phoneNumberError': false,
  'emailError': false,
  'floatingStateError': false,
  'reserveAdvanceError': false,
  'solNacNumberError': false,
  'informBillDateError': false,
  'observationsError': false,
  'contributorCodeError': false,
  'businessTypeError': false,
  'estSaleDateError': false,
  'estBillDateError': false,
};
